import React from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { timeZoneSelector } from 'Features/App/appSlice';
import { chartWidgetInfo, msIn10Minutes, sourceIdSetterForDataInfo } from '../utils';
import { SimpleChartWidget } from './SimpleWidgets/SimpleChartWidget';
import { LinearPlus } from './SimpleWidgets/LinearPlus/LinearPlus';
import { ChartWidgetData, ChartWidgetOptions } from '../types';

function useChartOptions(chartDatasetsInfo: ChartWidgetData[]) {
  const { datasourceId } = useParams();
  const zones = useSelector(timeZoneSelector, (a, b) => a.selectedUserTimeZone === b.selectedUserTimeZone);
  const zone = zones.stations;

  const options: ChartWidgetOptions = React.useMemo(() => {
    const chartCommonDataInfo = chartWidgetInfo(zone);
    return {
      commonDataInfo: chartCommonDataInfo,
      datasetsInfo: chartDatasetsInfo.map(sourceIdSetterForDataInfo(parseInt(datasourceId, 10))),
    };
  }, [zone, datasourceId, chartDatasetsInfo]);

  return { options, zone };
}

type WidgetChartProps = {
  chartDatasetInfo: ChartWidgetData[]
  isModLinear?: boolean
  pollingInterval?: number
}

function WidgetChartDefault({
  chartDatasetInfo,
  isModLinear = false,
  pollingInterval = msIn10Minutes,
}: WidgetChartProps) {
  const { options, zone } = useChartOptions(chartDatasetInfo);

  if (isModLinear) {
    return (
      <LinearPlus
        options={options}
        zone={zone}
        pollingInterval={pollingInterval}
        title=""
      />
    );
  }

  return (
    <SimpleChartWidget
      options={options}
      zone={zone}
      pollingInterval={pollingInterval}
      title=""
    />
  );
}

export const WidgetChart = React.memo(WidgetChartDefault);
WidgetChart.displayName = 'WidgetChart';
